
<div class="outer"  >

    <div class="container" 
    
    cdkDropListGroup>
        <span class="header">{{config?.demoTryASample}}</span>
        <div class="title into" style="--order: 1">{{config?.demoQuestionTitle}}</div>
        <div class=top>
            <div class="top-left">
                <div style="--order: 2" class="verse">{{config?.demoVerseRef}}</div>
            </div>
            <div style="--order: 4;" class="question"></div>
    
        </div>
        <div class="instruction" style="--order: 4;">{{config?.demoInstruction}}</div>
            <div 
                class="check-container"
                [ngClass]="{'correctFlex': allCorrect, 'incorrectFlex': !allCorrect}">
                <svg class="checkmark" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 52 52">
                <circle class="checkmark__circle" cx="26" cy="26" r="25" fill="none"/>
                <path class="checkmark__check" fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
                </svg>
        </div>
        <div class=blanks>
            <div style="--order: 5" class="sentense">{{config?.demoQuestion1}}</div>
            <div style="--order: 6" class="sentense">{{config?.demoQuestion2}}</div>
            <div 
                style="--order: 7"
                [cdkDropListData]="vpid1"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
                class="blank">
                <div
                    
                    *ngIf="!!vpid1[0]"
                    style="--order: 21"
                    [ngClass]="{correct: vpid1[0] == 'throne', incorrect:vpid1[0] != 'throne'}"
                    cdkDrag 
                    class="option-placed" >{{vpid1[0]}}</div>
                </div>
            <div style="--order: 8" class="sentense"> {{config?.demoQuestion3}}</div>
            <div
                style="--order: 9"
                [cdkDropListData]="vpid2"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
                class="blank">
                <div 
                    *ngIf="!!vpid2[0]" 
                    style="--order: 21"
                    [ngClass]="{correct: vpid2[0] == 'heavens', incorrect:vpid2[0] != 'heavens'}" 
                    cdkDrag 
                    class="option-placed">{{vpid2[0]}}</div>
            </div>
            <div style="--order: 10" class="sentense">{{config?.demoQuestion4}} </div>
            <div   
                style="--order: 11"
                [cdkDropListData]="vpid3"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
                class="blank">
                <div
                    *ngIf="!!vpid3[0]"
                    style="--order: 21"  
                    [ngClass]="{correct: vpid3[0] == 'sanctuary', incorrect:vpid3[0] != 'sanctuary'}"
                    cdkDrag 
                    class="option-placed">{{vpid3[0]}}</div>
            </div>
                <div style="--order: 12" class="sentense">{{config?.demoQuestion5}}</div>
            <div 
                style="--order: 13"
                [cdkDropListData]="vpid4"
                cdkDropList
                (cdkDropListDropped)="drop($event)"
                class="blank">
                <div 
                    *ngIf="!!vpid4[0]" 
                    [ngClass]="{correct: vpid4[0] == 'erected', incorrect:vpid4[0] != 'erected'}"
                    style="--order: 21"
                    cdkDrag 
                    class="option-placed">{{vpid4[0]}}</div>
            </div>
        </div>
        
        
        <div class="cloud" cdkDropList [cdkDropListData]="wordCloud" (cdkDropListDropped)="drop($event)">
            <div  
            *ngFor="let item of wordCloud; let i=index" 
            [@shake]=pulseState
            cdkDragStarted=drag($event)
            style="--order: 13"  
            [cdkDragData]=i 
            cdkDrag 
            class="option">{{item}}</div>

        </div>
        
        <div class="bottom">
            <div style="--order: 19" class="bottom-button" (click)="pulse()">{{config?.createMyAccount}}</div>
            <div *ngIf="!profile?.currentLesson" style="--order: 20" routerLink="/lesson/1" class="bottom-button">{{config?.tryLesson1}}</div>
            <div *ngIf="!!profile?.currentLesson" style="--order: 20" routerLink="/lesson/{{profile?.currentLesson}}" class="bottom-button">{{this.config?.resume}} {{profile?.currentLesson}}</div>
        </div>
    </div>
</div>